import { render, staticRenderFns } from "./JdCouponBar.vue?vue&type=template&id=0b797088&scoped=true&"
import script from "./JdCouponBar.vue?vue&type=script&lang=js&"
export * from "./JdCouponBar.vue?vue&type=script&lang=js&"
import style0 from "./JdCouponBar.vue?vue&type=style&index=0&id=0b797088&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b797088",
  null
  
)

export default component.exports